var render = function render(){var _vm=this,_c=_vm._self._c;return _c('badge',{attrs:{"loading":false,"type":_vm.statusType,"text":_vm.statusText}})
}
var staticRenderFns = []

export { render, staticRenderFns }